<template>
  <q-page :style-fn="styleFn" class="q-pt-sm">
    <BannerDeniedTimecard />
    <BannerProcessing />
    <!-- Timeline -->
    <div class="q-px-lg q-pb-md">
      <!-- Today info -->
      <timeline-header-date :date="date" />
      <div class="row">
        <TimelineWelcomeMessage />
        <div class="col">
          <!-- Timeline -->
          <timeline-base />
        </div>
        <div class="col-2 q-gutter-y-md">
          <timeline-scorecards-all :date="date" />
        </div>
      </div>
    </div>
  </q-page>
</template>
<script setup lang="ts">
import TimelineHeaderDate from '../components/TimelineHeaderDate.vue'
import TimelineBase from '../components/TimelineBase.vue'
import TimelineScorecardsAll from '../components/TimelineScorecardsAll.vue'
import BannerProcessing from '../components/BannerProcessing.vue'
import BannerDeniedTimecard from '../components/BannerDeniedTimecard.vue'
import TimelineWelcomeMessage from '../components/timeline/TimelineWelcomeMessage.vue'
import { inject, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useStoreProfiles } from '../store/useStoreProfiles'
import { useTaskProfiles } from '../store/useTaskProfiles'
const date = inject('date')
const setDate = inject<(date: Date) => void>('setDate')
//this is where the active timecard would be set back to today
if (setDate) setDate(new Date())
onMounted(() => {
  setTimeout(() => {
    //calc busiest data behind scenes w/o clogging the main thread
    const { getStores, getWorkView } = storeToRefs(useStoreProfiles())
    const { taskIndex } = storeToRefs(useTaskProfiles())
    getStores.value
    getWorkView.value
    taskIndex.value
  }, 0)
})
function styleFn(offset: any) {
  return { minHeight: offset ? `calc(97vh - ${offset}px)` : '100vh' }
}
</script>
